import React from 'react';
import '../style/CardsGrid.css';
import { Link } from 'react-router-dom';
import cards from '../datas/projetsData';


import Skeleton from 'react-loading-skeleton';  // Importe Skeleton

const CardsGrid = () => {
    return (
        <div className="grid-container">
            {cards.map((card) => (
                <Link
                    key={card.id}  // Gardez ceci ici pour l'élément Link
                    style={{ backgroundColor: card.color }}
                    to={`/details/${card.id}`}
                    className={`grid-item active 
                    ${card.type === "talk" ? 'grid-itemtalk' : ''}
                    ${card.id % 4 === 1 ? 'large' : ''} 
                    ${card.id % 2 === 0 ? 'haute' : ''}`} >

                    <div className={` ${card.type === 'talk' ? 'cardTextVisible' : 'cardText'}`}>
                        <h3 className="grid-title">{card.title ? card.title : <Skeleton width={200} />}</h3>
                        <p>{card.description ? card.description : <Skeleton count={3} />}</p>
                    </div>

                    {card.image ? (
                        <img src={card.image} alt={card.title} className="grid-image" loading="lazy" />
                    ) : (
                        <Skeleton height={200} width="100%" />  // Skeleton pour l'image
                    )}

                </Link>
            ))}
        </div>
    );
};

export default CardsGrid;

